import { cn } from "@tokenterminal/core/utils/cn"
import Link from "next/link"
import { makeButtonClassName } from "@/components/resources/components/ui/Button"
import {
  type Pagination as PaginationProps,
  pagePath,
  visiblePages,
} from "../utils/pagination"

const linkClassName = makeButtonClassName("medium", "default", "neutral")

/**
 * Archive page links. Plain links, so crawlers reach every page without JavaScript.
 * Not the shared core/ui Pagination: it renders buttons, which crawlers do not follow.
 */
export const Pagination = (pagination: PaginationProps) => {
  const { basePath, page, pageCount } = pagination
  if (pageCount < 2) {
    return null
  }

  return (
    <nav
      aria-label="Pagination"
      className="pt-4 pb-8 flex flex-wrap justify-center gap-2"
    >
      {page > 1 ? (
        <Link
          href={pagePath(basePath, page - 1)}
          rel="prev"
          className={linkClassName}
        >
          Previous
        </Link>
      ) : null}
      {visiblePages(pagination).map((n, i) =>
        n === null ? (
          <span
            key={`gap-${i}`}
            className="px-2 py-2 text-sm text-fg-secondary"
          >
            …
          </span>
        ) : (
          <Link
            key={n}
            href={pagePath(basePath, n)}
            aria-current={n === page ? "page" : undefined}
            className={cn(
              linkClassName,
              n === page && "bg-neutral-100 dark:bg-neutral-800"
            )}
          >
            {n}
          </Link>
        )
      )}
      {page < pageCount ? (
        <Link
          href={pagePath(basePath, page + 1)}
          rel="next"
          className={linkClassName}
        >
          Next
        </Link>
      ) : null}
    </nav>
  )
}
